import { render, staticRenderFns } from "./IncludedCreativeDimensions.vue?vue&type=template&id=b3498e60&"
import script from "./IncludedCreativeDimensions.vue?vue&type=script&lang=js&"
export * from "./IncludedCreativeDimensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports